import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useOrderStopPrice } from 'store/order/hooks'
import { updateCreateOrderOption } from 'store/spot/actions'

export const SpotSpotMarketPriceInput = memo(() => {
  const dispatch = useDispatch()
  const stopPrice = useOrderStopPrice()

  useEffect(() => {
    dispatch(
      updateCreateOrderOption({ option: 'limitPrice', value: stopPrice }),
    )
  }, [dispatch, stopPrice])

  return null
})
